import { render, staticRenderFns } from "./BaseFacebookShare.vue?vue&type=template&id=d30194f0&"
import script from "./BaseFacebookShare.vue?vue&type=script&lang=js&"
export * from "./BaseFacebookShare.vue?vue&type=script&lang=js&"
import style0 from "./BaseFacebookShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports